import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

const MaintenanceAndRisk = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Maintenance and Risk of Loss</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Seller will maintain the Property including, but not limited to,
          structures, grounds, fixtures, appliances, and personal property
          specifically listed in this Agreement in its present condition, normal
          wear and tear excepted.
        </Text>

        <Text style={styles.listItem}>
          2. If any part of the Property included in the sale{' '}
          <Text style={styles.DangerText}>fails before settlement</Text>, Seller
          will:
        </Text>

        <View style={styles.list}>
          <Text style={styles.listItem}>
            a. <Text style={styles.ClauseText}>Repair or replace</Text> that
            part of the Property before settlement,
          </Text>

          <Text style={styles.listItem}>
            b. Provide{' '}
            <Text style={styles.ClauseText}>prompt written notice</Text> to
            Buyer of Seller's decision to:
          </Text>

          <View style={styles.list}>
            <Text style={styles.listItem}>
              i. <Text style={styles.InfoText}>Credit Buyer at settlement</Text>{' '}
              for the <Text style={styles.InfoText}>fair market value</Text> of
              the failed part of the Property, as acceptable to the mortgage
              lender,
            </Text>

            <Text style={styles.listItem}>
              ii. <Text style={styles.DangerText}>Not repair or replace</Text>{' '}
              the failed part of the Property, and{' '}
              <Text style={styles.DangerText}>not credit Buyer</Text> at
              settlement for the fair market value of the failed part of the
              Property.
            </Text>
          </View>

          <Text style={styles.listItem}>
            c. If Seller does not repair or replace the failed part of the
            Property or agree to credit Buyer for its fair market value, or if
            Seller <Text style={styles.DangerText}>fails to notify Buyer</Text>{' '}
            of Seller's choice, Buyer will{' '}
            <Text style={styles.DangerText}>notify Seller in writing</Text>{' '}
            within {contract?.contingency?.homeinspectionNegotiationDays ?? 0}{' '}
            days or before Settlement Date, whichever is earlier, that Buyer
            will:
          </Text>

          <View style={styles.list}>
            <Text style={styles.listItem}>
              i.{' '}
              <Text style={styles.ClauseText}>
                Accept the Property and agree to the Release clause of this
                Agreement
              </Text>
            </Text>

            <Text style={styles.listItem}>
              ii.{' '}
              <Text style={styles.DangerText}>Terminate this Agreement</Text> by
              written notice to Seller, with{' '}
              <Text style={styles.DangerText}>all deposit monies returned</Text>{' '}
              to Buyer according to the terms of this Agreement.
            </Text>
          </View>

          <Text style={styles.listItem}>
            d. If Buyer <Text style={styles.DangerText}>fails to respond</Text>{' '}
            within the 5 days or{' '}
            <Text style={styles.DangerText}>fails to terminate</Text> this
            Agreement by written notice to Seller within that time, Buyer will{' '}
            <Text style={styles.ClauseText}>
              accept the Property and agree to the Release clause of this
              Agreement
            </Text>
          </Text>
        </View>

        <Text style={styles.listItem}>
          3.{' '}
          <Text style={styles.DangerText}>
            Seller bears the risk of loss from fire or other casualties until
            settlement.
          </Text>{' '}
          If any property included in this sale is destroyed and not replaced
          prior to settlement, Buyer will either:
        </Text>

        <View style={styles.list}>
          <Text style={styles.listItem}>
            a.{' '}
            <Text style={styles.InfoText}>
              Accept the Property in its then current condition together with
              the proceeds of any insurance recovery obtainable by Seller
            </Text>
            , OR
          </Text>

          <Text style={styles.listItem}>
            b. <Text style={styles.DangerText}>Terminate this Agreement</Text>{' '}
            by written notice to Seller, with{' '}
            <Text style={styles.DangerText}>all deposit money returned</Text> to
            Buyer according to the terms of this Agreement.
          </Text>
        </View>
      </View>
    </View>
  );
};

export default MaintenanceAndRisk;
